<template>
  <el-dialog
    title="选择关联拜访"
    :visible.sync="dialogVisible"
    :width="$utils.isMobile() ? '95%' : '620px'"
    :before-close="handleClose"
    custom-class="visit-select-dialog"
    append-to-body
  >
    <div v-loading="loading">
      <div class="tip-text" v-if="!userId || !invoiceDate">
        请先选择报销人和发生日期
      </div>
      <template v-else>
        <div class="filter-bar">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            size="small"
            class="date-picker"
            @change="handleDateChange"
          ></el-date-picker>
          <div class="school-filter-inline" v-if="schoolOptions.length > 0">
            <span class="filter-label">学校</span>
            <el-select
              v-model="schoolFilter"
              placeholder="全部学校"
              clearable
              size="small"
              filterable
              class="school-select"
            >
              <el-option
                v-for="opt in schoolOptions"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="visit-list" v-if="filteredVisitList.length">
          <div
            v-for="item in filteredVisitList"
            :key="item.id"
            class="visit-item"
            :class="{ selected: selectedIds.indexOf(item.id) !== -1 }"
            @click="toggleItem(item)"
          >
            <div class="visit-checkbox">
              <i :class="selectedIds.indexOf(item.id) !== -1 ? 'el-icon-check' : ''"></i>
            </div>
            <div class="visit-info">
              <div class="visit-header">
                <span class="visit-date"><i class="el-icon-date"></i>{{ item.visitDay }}</span>
                <span class="visit-school"><i class="el-icon-location-outline"></i>{{ item.sname || '--' }}</span>
              </div>
              <div class="visit-detail" v-if="item.target">
                <span class="detail-label">目标：</span>
                <span class="detail-value">{{ item.target }}</span>
              </div>
              <div class="visit-detail" v-if="item.result">
                <span class="detail-label">结果：</span>
                <span class="detail-value">{{ item.result }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="!loading" class="empty-list">
          {{ visitList.length > 0 && !filteredVisitList.length ? '当前筛选学校下暂无拜访记录' : '该时间范围内暂无拜访记录' }}
        </div>
      </template>
    </div>
    <div slot="footer" class="dialog-footer-wrap">
      <div class="footer-left">
        <el-checkbox
          v-if="filteredVisitList.length > 0"
          :value="isAllSelected"
          :indeterminate="isIndeterminate"
          @change="toggleSelectAll"
          class="select-all-check"
        >全选当前</el-checkbox>
      </div>
      <div class="footer-right">
        <span class="selected-count" v-if="selectedVisits.length > 0">
          已选 {{ selectedVisits.length }} 个
        </span>
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="confirm" :disabled="!userId || !invoiceDate">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { findRecentVisits } from "@/api/invoice/index.js";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: [String, Number],
      default: "",
    },
    invoiceDate: {
      type: String,
      default: "",
    },
    selectedVisitIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      visitList: [],
      selectedVisits: [],
      selectedIds: [],
      dateRange: [],
      schoolFilter: "",
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    // 从当前查询结果中提取去重学校列表
    schoolOptions() {
      let map = new Map();
      this.visitList.forEach((v) => {
        if (v.sname) {
          map.set(v.sname, { value: v.sname, label: v.sname });
        }
      });
      return Array.from(map.values());
    },
    // 按学校筛选后的拜访列表
    filteredVisitList() {
      if (!this.schoolFilter) return this.visitList;
      return this.visitList.filter((v) => v.sname === this.schoolFilter);
    },
    // 当前筛选列表是否全部选中
    isAllSelected() {
      if (this.filteredVisitList.length === 0) return false;
      return this.filteredVisitList.every((v) => this.selectedIds.indexOf(v.id) !== -1);
    },
    // 当前筛选列表是否部分选中（半选状态）
    isIndeterminate() {
      let selectedCount = this.filteredVisitList.filter((v) => this.selectedIds.indexOf(v.id) !== -1).length;
      return selectedCount > 0 && selectedCount < this.filteredVisitList.length;
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.selectedVisits = [];
        this.selectedIds = [...this.selectedVisitIds];
        if (this.userId && this.invoiceDate) {
          this.dateRange = this.getDefaultDateRange();
          this.loadVisits();
        }
      }
    },
  },
  methods: {
    getDefaultDateRange() {
      let d = new Date(this.invoiceDate);
      let day = d.getDay();
      let monday = new Date(d);
      let diff = day === 0 ? -6 : 1 - day;
      monday.setDate(monday.getDate() + diff);
      let start = new Date(monday);
      start.setDate(start.getDate() - 7);
      let end = new Date(monday);
      end.setDate(end.getDate() + 6);
      return [this.formatDate(start), this.formatDate(end)];
    },
    formatDate(d) {
      let y = d.getFullYear();
      let m = String(d.getMonth() + 1).padStart(2, "0");
      let day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    },
    toggleItem(item) {
      let idx = this.selectedIds.indexOf(item.id);
      if (idx === -1) {
        this.selectedIds.push(item.id);
        this.selectedVisits.push(item);
      } else {
        this.selectedIds.splice(idx, 1);
        this.selectedVisits = this.selectedVisits.filter((v) => v.id !== item.id);
      }
    },
    handleDateChange() {
      if (this.dateRange && this.dateRange.length === 2) {
        this.loadVisits();
      }
    },
    loadVisits() {
      this.loading = true;
      let [startDay, endDay] = this.dateRange;
      findRecentVisits({ userId: this.userId, startDay, endDay })
        .then((res) => {
          this.visitList = res.data || [];
          this.schoolFilter = "";
          // 同步已选中的完整对象
          this.syncSelectedVisits();
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          if (err.status === 888) return;
          this.$MessageBox.MessageWarning(err.data.msg);
        });
    },
    // 全选/取消全选当前筛选后的列表
    toggleSelectAll(val) {
      if (val) {
        this.filteredVisitList.forEach((item) => {
          if (this.selectedIds.indexOf(item.id) === -1) {
            this.selectedIds.push(item.id);
            this.selectedVisits.push(item);
          }
        });
      } else {
        this.filteredVisitList.forEach((item) => {
          let idx = this.selectedIds.indexOf(item.id);
          if (idx !== -1) {
            this.selectedIds.splice(idx, 1);
          }
        });
        let filteredIds = new Set(this.filteredVisitList.map((v) => v.id));
        this.selectedVisits = this.selectedVisits.filter((v) => !filteredIds.has(v.id));
      }
    },
    // 新列表加载后，重新构建 selectedVisits（保持已选的）
    syncSelectedVisits() {
      let newSelected = [];
      for (let id of this.selectedIds) {
        let found = this.visitList.find((v) => v.id === id);
        if (found) {
          newSelected.push(found);
        }
      }
      this.selectedVisits = newSelected;
    },
    confirm() {
      this.$emit("select", this.selectedVisits);
      this.dialogVisible = false;
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.filter-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 0.8rem;
  .date-picker {
    flex: 1;
    min-width: 0;
  }
  .school-filter-inline {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
  }
  .filter-label {
    font-size: 0.82rem;
    color: #606266;
    white-space: nowrap;
  }
  .school-select {
    width: 150px;
  }
}
.tip-text {
  text-align: center;
  color: #909399;
  padding: 3rem 0;
}
.empty-list {
  text-align: center;
  color: #c0c4cc;
  padding: 2.5rem 0;
  font-size: 0.9rem;
}
.visit-list {
  max-height: 420px;
  overflow-y: auto;
  padding: 2px;
  .visit-item {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 0.7rem 0.8rem;
    border-radius: 8px;
    cursor: pointer;
    border: 1px solid #f0f0f0;
    margin-bottom: 8px;
    transition: all 0.15s;
    &:hover {
      border-color: #b3d8ff;
      background: #f5faff;
    }
    &.selected {
      border-color: #409eff;
      background: #ecf5ff;
    }
    .visit-checkbox {
      width: 18px;
      height: 18px;
      border-radius: 4px;
      border: 2px solid #dcdfe6;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 2px;
      font-size: 12px;
      color: #fff;
      transition: all 0.15s;
    }
    &.selected .visit-checkbox {
      background: #409eff;
      border-color: #409eff;
    }
    .visit-info {
      flex: 1;
      min-width: 0;
      .visit-header {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 4px;
        .visit-date {
          font-size: 0.85rem;
          font-weight: 600;
          color: #303133;
          display: inline-flex;
          align-items: center;
          gap: 3px;
          i { font-size: 0.8rem; color: #909399; }
        }
        .visit-school {
          font-size: 0.82rem;
          color: #606266;
          display: inline-flex;
          align-items: center;
          gap: 3px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          i { font-size: 0.8rem; color: #909399; }
        }
      }
      .visit-detail {
        font-size: 0.78rem;
        color: #909399;
        line-height: 1.5;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        .detail-label {
          color: #c0c4cc;
        }
      }
    }
  }
}
.selected-count {
  color: $primary-btn-color;
  margin-right: 1rem;
  font-size: 0.9rem;
}
.select-all-check {
  /* 复选框本身无需额外边距，由父级 footer 两端对齐控制 */
}
.dialog-footer-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.footer-left {
  display: flex;
  align-items: center;
}
.footer-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}
</style>
<style lang="scss">
.visit-select-dialog {
  border-radius: 12px;
  .el-dialog__header {
    padding: 14px 20px;
    border-bottom: 1px solid #f0f2f5;
  }
  .el-dialog__body {
    padding: 16px 20px;
  }
  .el-dialog__footer {
    padding: 10px 20px;
    border-top: 1px solid #f0f2f5;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
